import cn from 'classnames'

import { useEffect, useState } from 'react'

import { IInstructionProps } from './instruction.props'
import styles from './styles.module.scss'

export default function Instruction({ videoId, title, className }: IInstructionProps) {
  const [width, setScreenWidth] = useState<number>(0)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setScreenWidth(window.innerWidth)
    }
  }, [])

  return (
    <div className={cn(styles.instruction, className)}>
      <h2 className={styles.title}>{title}</h2>

      <iframe
        width={width > 765 ? 776 : '100%'}
        className={styles.iframe}
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  )
}
